import React, { useEffect, useState } from 'react';
import Modal from '../../BaseModule/Components/Modal';
import { Size } from '../../../Enums/Size.enum';
import Text from '../../BaseModule/Components/Text';
import Button from '../../BaseModule/Components/Button';
import { isMobile, isIOS } from 'react-device-detect';
import LocalStorage from '../../../Services/LocalStorage';

interface Props {
	appLinkIos: string;
	appLinkAndroid: string;
	location: 'loginPage' | 'connectWithDoctorPage';
}

const CompatibilityCheck: React.FC<Props> = ({
	appLinkIos,
	appLinkAndroid,
	location,
}) => {
	const localStorageKey: string = 'compatibilityCheck_' + location;

	const [isOpen, setIsOpen] = useState(false);

	const handleRedirectToStore = () => {
		// @ts-ignore
		window.location.href = isIOS ? appLinkIos : appLinkAndroid;
	};

	const handleClose = () => {
		LocalStorage.set(localStorageKey, { seen: true });
		setIsOpen(false);
	};

	useEffect(() => {
		const data = LocalStorage.get(localStorageKey);
		if (isMobile && !data?.seen) {
			setIsOpen(true);
		}
	}, []);

	return (
		<Modal opened={isOpen} onClose={handleClose} size={Size.SM}>
			<Modal.Header title='component.compatibilityCheck.title' />
			<Modal.Content>
				<Text tx='component.compatibilityCheck.text' />
				<div className='mt-3'>
					<Button
						onClick={handleRedirectToStore}
						text={
							isIOS
								? 'component.compatibilityCheck.appStore'
								: 'component.compatibilityCheck.googlePlay'
						}
					/>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default CompatibilityCheck;
